import type { ExecutionLifecycleUpdate } from '@toolproof-core/lib/_contract/workflow-execution';

import type { PrimitiveExecutionState } from '@/workflowExecution/_contract/types';

function merge<K extends string | number, V>(previous: Record<K, V>, patch: Partial<Record<K, V>> | undefined): Record<K, V> {
    const next = { ...previous };
    for (const key in patch) {
        const value = patch[key];
        if (value !== undefined) next[key] = value;
    }
    return next;
}

export function applyExecutionUpdate(state: PrimitiveExecutionState, update: ExecutionLifecycleUpdate): PrimitiveExecutionState {
    return {
        mutableWorkflow: {
            ...state.mutableWorkflow,
            ...update.mutableWorkflow,
            workflowState: { ...state.mutableWorkflow.workflowState, ...update.mutableWorkflow?.workflowState },
        },
        toolMap: update.toolMap ?? state.toolMap,
        currentThreadIndex: update.currentThreadIndex === undefined ? state.currentThreadIndex : update.currentThreadIndex,
        stepCounters: merge(state.stepCounters, update.stepCounters),
        iterationCounters: merge(state.iterationCounters, update.iterationCounters),
        tracePoints: [...state.tracePoints, ...update.tracePoints ?? []],
        tracePointIndexCounters: merge(state.tracePointIndexCounters, update.tracePointIndexCounters),
        rootLoopStepKeyByCloneLoopStepKey: merge(state.rootLoopStepKeyByCloneLoopStepKey, update.rootLoopStepKeyByCloneLoopStepKey),
        rootBranchStepKeyByRemainderBranchStepKey: merge(
            state.rootBranchStepKeyByRemainderBranchStepKey, update.rootBranchStepKeyByRemainderBranchStepKey,
        ),
        loopLineageEntryByKey: merge(state.loopLineageEntryByKey, update.loopLineageEntryByKey),
        branchExitRebindGuardByThreadIndex: merge(state.branchExitRebindGuardByThreadIndex, update.branchExitRebindGuardByThreadIndex),
        threadEndMap: merge(state.threadEndMap, update.threadEndMap),
        startEmitted: update.startEmitted ?? state.startEmitted,
        endEmitted: update.endEmitted ?? state.endEmitted,
    };
}
